import React from 'react';
import urls, { relativeUrl } from '@/constants/urls';
import RibbonMenu from '@/containers/ribbon/RibbonMenu';

const UserGroupsLauncherMenu = () => (
  <RibbonMenu
    name="usergroups"
    icon="users"
    message="fair.launcher.usergroups"
    url={`#${relativeUrl(urls.USER_GROUPS)}`}
    className="aridhia-usergroups-launcher-menu"
  />
);

export default UserGroupsLauncherMenu;
